import { merge } from "effector";
import { ActivitiesEndpoint } from "./endpoints/activities";
import { PackagesEndpoint } from "./endpoints/packages";
import { countdownApi } from "./shared/countdown";

merge([
  ActivitiesEndpoint.reserve.call.done,
  PackagesEndpoint.reserve.call.done,
]).watch(() => {
  countdownApi.start();
});
